import React, { useRef, useState } from 'react';
import { getFieldDataTypeIcon } from '../../../../core/utils/data-type-icon';
import { HdCoordinatedScroll } from '../../../../a11y/scroll/components/coordinated-scroll/HdCoordinatedScroll';
import ScrollToTopButton from '../../../../a11y/scroll/components/scroll-to-top-button/ScrollToTopButton';
import { HdIcon, HdTooltip } from '../../../../components';
import styles from './styles.module.scss';

export function ObjectExplorerFields({
  fields
}: { fields: any[]}) {
  const [ coordinatedScrollElement, setCoordinatedScrollElement ] = useState(null);

  const getFieldDisplayName = (field) => {
    if (field.display_name) {
      return field.display_name;
    }

    return field.name;
  };

  return (
    <HdCoordinatedScroll elRef={coordinatedScrollElement}>
      <div className={styles.objectExplorerList} ref={setCoordinatedScrollElement} id='object_explorer_list'>
        {fields.map((field, index) => (
          <div className={styles.objectFieldDetails} key={index}>
            <span className='datatype-icon'>
              <HdIcon name={getFieldDataTypeIcon(field.type)} size={1} />
            </span>

            <HdTooltip title={getFieldDisplayName(field)} enableOnTextOverflow>
              <span
                className='text-ellipsis ml-2'
              >
              {getFieldDisplayName(field)}
            </span>
            </HdTooltip>
          </div>
        ))}

        <ScrollToTopButton scrollViewportId='object_explorer_list' />
      </div>
    </HdCoordinatedScroll>
  );
}
